export { TixologiWidgetIframe } from "./TixologiWidgetIframe";
